import { css } from "lit";
import { Style } from "../Styles";

export const style = css`
    ${Style}

    :host {
        display: block;
    }

    .top-contributor .title-row {
        align-items: center;
    }

    sl-avatar {
        --size: 2.3em;
    }

    hr {
        border-top: 1px solid grey;
        border-bottom: none;
        width: 100%;
    }
`;
